// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2ENh5","addWidgetButton":"Header_addWidgetButton__V3kWV","dashboardTabs":"Header_dashboardTabs__2TceY","active":"Header_active__3-EXJ"};